export default __webpack_public_path__ + "static/media/apiary3.e3e5e5a8.png";